import { FILES } from "i18n/constants";
import { Trans } from "i18n/Trans";
import React from "react";

export const PricesFootnote = () => (
  <p className="font-semibold">
    <Trans
      i18nKey={`${FILES.PRICES}.footnote`}
      components={[
        <a
          className="text-[rgb(1,3,4)] underline!"
          style={{
            textUnderlinePosition: "under"
          }}
          target="_blank"
          href="https://www.gemini.com/fees"
          rel="noreferrer"
        />
      ]}
    />
  </p>
);
